<payee-popup title="{{ 'DISCARD_CASE_DIALOG.TITLE' | translate }}">
  <div class="img-box flex vcenter hcenter">
    <img
      alt=""
      src="assets/shared/global-images/icons/trash-grey.svg"
      height="71.43px"
    />
  </div>
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="alert-red"
      width="wide"
      height="tall"
      (click)="submit()"
    >
      {{ "DISCARD_CASE_DIALOG.CONFIRM_DELETE" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      class="payee-button cancel-button"
      payee-button
      color="white"
      width="wide"
      height="tall"
      [isBorderButton]="true"
      [mat-dialog-close]="false"
    >
      {{ "DISCARD_CASE_DIALOG.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
